import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "../constants/frontendPaths";

const EXCLUDED_ROUTES = [new RegExp(`^${ROUTES.transactionDetails.replace(":paymentId", ".*")}$`)];

const usePageTracking = () => {
	const location = useLocation();

	useEffect(() => {
		const isExcluded = EXCLUDED_ROUTES.some((pattern) => pattern.test(location.pathname));
		if (window.gtag && !isExcluded) {
			window.gtag("config", "G-P2GTZHRRJE", {
				page_path: location.pathname
			});
		}
	}, [location]);
};

export default usePageTracking;
